export type AndroidInterruptionFilter = 'all' | 'priority' | 'alarms' | 'none';
export type AndroidRingerMode = 'normal' | 'vibrate' | 'silent';
export type AndroidStandbyBucket = 'active' | 'working_set' | 'frequent' | 'rare' | 'restricted';

export interface AndroidHealthFields {
  channelVisibility?: number;
  androidNotificationsEnabled?: boolean;
  androidInterruptionFilter?: AndroidInterruptionFilter;
  androidAlertsBypassDnd?: boolean;
  androidRingerMode?: AndroidRingerMode;
  androidBackgroundRestricted?: boolean;
  androidIgnoringBatteryOptimizations?: boolean;
  androidStandbyBucket?: AndroidStandbyBucket;
}

export interface AndroidNotificationSettings {
  notificationsEnabled?: boolean;
  interruptionFilter?: AndroidInterruptionFilter | 'unknown';
  alertsBypassDnd?: boolean;
  ringerMode?: AndroidRingerMode | 'unknown';
  ignoringBatteryOptimizations?: boolean;
  backgroundRestricted?: boolean;
  standbyBucket?: AndroidStandbyBucket | 'unknown';
}

function known<T extends string>(value: T | 'unknown' | undefined): T | undefined {
  return value === 'unknown' ? undefined : value;
}

export function androidHealthFields(settings: AndroidNotificationSettings): AndroidHealthFields {
  const fields: AndroidHealthFields = {
    androidNotificationsEnabled: settings.notificationsEnabled,
    androidInterruptionFilter: known(settings.interruptionFilter),
    androidAlertsBypassDnd: settings.alertsBypassDnd,
    androidRingerMode: known(settings.ringerMode),
    androidBackgroundRestricted: settings.backgroundRestricted,
    androidIgnoringBatteryOptimizations: settings.ignoringBatteryOptimizations,
    androidStandbyBucket: known(settings.standbyBucket),
  };
  return Object.fromEntries(
    Object.entries(fields).filter(([, value]) => value !== undefined),
  ) as AndroidHealthFields;
}
